import { Box, Typography } from '@mui/material';
import JobsHistoryContainer from '@/features/jobs/components/JobsHistoryContainer';

export default function HistoryPage() {
  return (
    <Box>
      <Typography variant="h4" fontWeight={600} gutterBottom>
        Historial de Jobs
      </Typography>
      <JobsHistoryContainer />
    </Box>
  );
}
